/* unplugin-vue-components disabled */import { render } from "./UserRightManagement.vue?vue&type=template&id=3c19441e&scoped=true&ts=true"
import script from "./UserRightManagement.vue?vue&type=script&lang=ts"
export * from "./UserRightManagement.vue?vue&type=script&lang=ts"

import "./UserRightManagement.vue?vue&type=style&index=0&id=3c19441e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c19441e"]])

export default __exports__